import { defineMessages } from 'react-intl';

export const memberDetailMessages = defineMessages({
  loadingMember: {
    id: 'MemberDetail.loadingMember',
    defaultMessage: 'Loading member…',
  },
  memberNotFound: {
    id: 'MemberDetail.memberNotFound',
    defaultMessage: 'Member not found.',
  },
  memberUnavailable: {
    id: 'MemberDetail.memberUnavailable',
    defaultMessage: 'Unable to load this member right now.',
  },
  memberNameUnavailable: {
    id: 'MemberDetail.memberNameUnavailable',
    defaultMessage: 'Name unavailable',
  },
  unknownMember: {
    id: 'MemberDetail.unknownMember',
    defaultMessage: 'Unable to load this member right now.',
  },
  menuLabel: {
    id: 'MemberDetail.menuLabel',
    defaultMessage: 'Member menu',
  },
  landingLabel: {
    id: 'MemberDetail.landingLabel',
    defaultMessage: 'Home',
  },
  landingTitle: {
    id: 'MemberDetail.landingTitle',
    defaultMessage: 'Home',
  },
  landingDescription: {
    id: 'MemberDetail.landingDescription',
    defaultMessage: 'Choose a member detail view or start a Zori chat.',
  },
  landingQuickAccessTitle: {
    id: 'MemberDetail.landingQuickAccessTitle',
    defaultMessage: 'Quick access',
  },
  landingQuickAccessSubtitle: {
    id: 'MemberDetail.landingQuickAccessSubtitle',
    defaultMessage: 'Your most used tools',
  },
  landingOtherToolsTitle: {
    id: 'MemberDetail.landingOtherToolsTitle',
    defaultMessage: 'Other tools',
  },
  landingOtherToolsSubtitle: {
    id: 'MemberDetail.landingOtherToolsSubtitle',
    defaultMessage: 'Additional resources and tools',
  },
  landingOnboardingSnapshotDescription: {
    id: 'MemberDetail.landingOnboardingSnapshotDescription',
    defaultMessage: 'Member onboarding progress, appointments, and more',
  },
  landingJourneyReportDescription: {
    id: 'MemberDetail.landingJourneyReportDescription',
    defaultMessage: 'APEX journey stages and touchpoints with source evidence',
  },
  journeyReportLabel: {
    id: 'MemberDetail.journeyReportLabel',
    defaultMessage: 'Journey Report',
  },
  journeyReport: {
    id: 'MemberDetail.journeyReport',
    defaultMessage: 'Journey Report',
  },
  landingAnnualReportDescription: {
    id: 'MemberDetail.landingAnnualReportDescription',
    defaultMessage: "Review, edit, and present the member's annual report",
  },
  landingCompositeReportDescription: {
    id: 'MemberDetail.landingCompositeReportDescription',
    defaultMessage: 'Generate and review composite reports for this member',
  },
  landingActionPlanDescription: {
    id: 'MemberDetail.landingActionPlanDescription',
    defaultMessage: 'Tasks, recommendations, and follow-up actions',
  },
  landingAiToolsDescription: {
    id: 'MemberDetail.landingAiToolsDescription',
    defaultMessage: 'Zori AI generated report templates and generated reports',
  },
  landingRuleActionAuditDescription: {
    id: 'MemberDetail.landingRuleActionAuditDescription',
    defaultMessage:
      'Audit rule actions, extraction tasks, and member notifications',
  },
  landingLabsDescription: {
    id: 'MemberDetail.landingLabsDescription',
    defaultMessage: 'Medical results and biomarker trends',
  },
  landingDocumentsDescription: {
    id: 'MemberDetail.landingDocumentsDescription',
    defaultMessage:
      'Files, Notes, Medications, Procedures, Conditions, Allergies, Immunizations',
  },
  landingSurveysDescription: {
    id: 'MemberDetail.landingSurveysDescription',
    defaultMessage: 'Surveys, responses, calculations, and consents',
  },
  landingMemberAppDescription: {
    id: 'MemberDetail.landingMemberAppDescription',
    defaultMessage: 'Member-facing app layout and content preview',
  },
  landingOmicsExplorerDescription: {
    id: 'MemberDetail.landingOmicsExplorerDescription',
    defaultMessage: 'Genomics tests, variants, and omics insights',
  },
  landingZoriChatDescription: {
    id: 'MemberDetail.landingZoriChatDescription',
    defaultMessage: 'Discuss this member with Zori AI and review chat history.',
  },
  zoriChatLabel: {
    id: 'MemberDetail.zoriChatLabel',
    defaultMessage: 'Zori Chat',
  },
  zoriPulseScanButton: {
    id: 'MemberDetail.zoriPulseScanButton',
    defaultMessage: 'Zori AI Scan',
  },
  zoriPulseScanRunning: {
    id: 'MemberDetail.zoriPulseScanRunning',
    defaultMessage: 'Scanning…',
  },
  zoriPulseScanComplete: {
    id: 'MemberDetail.zoriPulseScanComplete',
    defaultMessage: 'Zori AI Scan complete',
  },
  zoriPulseScanFailed: {
    id: 'MemberDetail.zoriPulseScanFailed',
    defaultMessage: 'Zori AI Scan failed. Please try again later.',
  },
  zoriPulseScanInvokeError: {
    id: 'MemberDetail.zoriPulseScanInvokeError',
    defaultMessage: 'Unable to start Zori AI Scan.',
  },
  onboardingSnapshotLabel: {
    id: 'MemberDetail.onboardingSnapshotLabel',
    defaultMessage: 'Onboarding Snapshot',
  },
  regenerativeMedicineOpsLabel: {
    id: 'MemberDetail.regenerativeMedicineOpsLabel',
    defaultMessage: 'Regenerative Medicine Ops',
  },
  landingRegenerativeMedicineOpsDescription: {
    id: 'MemberDetail.landingRegenerativeMedicineOpsDescription',
    defaultMessage:
      'Operational lifecycle view for regenerative medicine (read-only, FHIR-backed in v0).',
  },
  regenerativeMedicineOps: {
    id: 'MemberDetail.regenerativeMedicineOps',
    defaultMessage: 'Regenerative Medicine Ops',
  },
  annualReportLabel: {
    id: 'MemberDetail.annualReportLabel',
    defaultMessage: 'Annual Report',
  },
  compositeReportLabel: {
    id: 'MemberDetail.compositeReportLabel',
    defaultMessage: 'Composite Report',
  },
  actionPlanLabel: {
    id: 'MemberDetail.actionPlanLabel',
    defaultMessage: 'Action Plan',
  },
  aiToolsLabel: {
    id: 'MemberDetail.aiToolsLabel',
    defaultMessage: 'Zori Reports',
  },
  ruleActionAuditLabel: {
    id: 'MemberDetail.ruleActionAuditLabel',
    defaultMessage: 'Rule Actions Audit',
  },
  labsLabel: {
    id: 'MemberDetail.labsLabel',
    defaultMessage: 'Labs and Data',
  },
  surveysLabel: {
    id: 'MemberDetail.surveysLabel',
    defaultMessage: 'Surveys & Consents',
  },
  documentsLabel: {
    id: 'MemberDetail.documentsLabel',
    defaultMessage: 'Documents and Medical History',
  },
  memberAppLabel: {
    id: 'MemberDetail.memberAppLabel',
    defaultMessage: 'Member App',
  },
  onboardingSnapshot: {
    id: 'MemberDetail.onboardingSnapshot',
    defaultMessage: 'Onboarding Snapshot',
  },
  onboardingSnapshotLink: {
    id: 'MemberDetail.onboardingSnapshotLink',
    defaultMessage: 'View in Onboarding Snapshot workflow',
  },
  annualReport: {
    id: 'MemberDetail.annualReport',
    defaultMessage: 'Annual Report',
  },
  compositeReport: {
    id: 'MemberDetail.compositeReport',
    defaultMessage: 'Composite Report',
  },
  actionPlan: {
    id: 'MemberDetail.actionPlan',
    defaultMessage: 'Action Plan',
  },
  aiTools: {
    id: 'MemberDetail.aiTools',
    defaultMessage: 'Zori Reports',
  },
  ruleActionAudit: {
    id: 'MemberDetail.ruleActionAudit',
    defaultMessage: 'Rule Actions Audit',
  },
  labsAndData: {
    id: 'MemberDetail.labsAndData',
    defaultMessage: 'Labs and Data',
  },
  surveys: {
    id: 'MemberDetail.surveys',
    defaultMessage: 'Surveys & Consents',
  },
  documents: {
    id: 'MemberDetail.documents',
    defaultMessage: 'Documents',
  },
  memberDocumentsDeleteButton: {
    id: 'MemberDetail.memberDocumentsDeleteButton',
    defaultMessage: 'Delete member file',
  },
  memberDocumentsDeleteConfirmTitle: {
    id: 'MemberDetail.memberDocumentsDeleteConfirmTitle',
    defaultMessage: 'Delete member file?',
  },
  memberDocumentsDeleteConfirmBody: {
    id: 'MemberDetail.memberDocumentsDeleteConfirmBody',
    defaultMessage:
      'This permanently removes this document from the chart. This cannot be undone.',
  },
  memberDocumentsDeleteConfirm: {
    id: 'MemberDetail.memberDocumentsDeleteConfirm',
    defaultMessage: 'Delete',
  },
  memberDocumentsDeleteCancel: {
    id: 'MemberDetail.memberDocumentsDeleteCancel',
    defaultMessage: 'Cancel',
  },
  memberDocumentsDeleteSuccess: {
    id: 'MemberDetail.memberDocumentsDeleteSuccess',
    defaultMessage:
      'File has been deleted, it may take a few seconds to disappear from the documents list',
  },
  memberDocumentsExtractionButton: {
    id: 'MemberDetail.memberDocumentsExtractionButton',
    defaultMessage: 'Analyze with Zori AI',
  },
  memberDocumentsExtractionSelectColumn: {
    id: 'MemberDetail.memberDocumentsExtractionSelectColumn',
    defaultMessage: 'Select document',
  },
  memberDocumentsExtractionSelectAll: {
    id: 'MemberDetail.memberDocumentsExtractionSelectAll',
    defaultMessage: 'Select all documents',
  },
  memberDocumentsExtractionBulkButton: {
    id: 'MemberDetail.memberDocumentsExtractionBulkButton',
    defaultMessage:
      'Analyze ({count}) {count, plural, one {document} other {documents}} with Zori AI',
  },
  memberDocumentsExtractionBulkClearSelection: {
    id: 'MemberDetail.memberDocumentsExtractionBulkClearSelection',
    defaultMessage: 'Clear selection',
  },
  memberDocumentsExtractionBulkStarting: {
    id: 'MemberDetail.memberDocumentsExtractionBulkStarting',
    defaultMessage: 'Starting analysis for selected documents…',
  },
  memberDocumentsExtractionBulkSuccess: {
    id: 'MemberDetail.memberDocumentsExtractionBulkSuccess',
    defaultMessage:
      'Started Zori analysis for {started, plural, one {# document} other {# documents}}. Skipped {skipped, plural, one {# document} other {# documents}} that were already analyzed or in progress.',
  },
  memberDocumentsExtractionBulkPartial: {
    id: 'MemberDetail.memberDocumentsExtractionBulkPartial',
    defaultMessage:
      'Started Zori analysis for {started, plural, one {# document} other {# documents}}. Skipped {skipped, plural, one {# document} other {# documents}}. {failed, plural, one {# request failed} other {# requests failed}}.',
  },
  memberDocumentsExtractionBulkFailed: {
    id: 'MemberDetail.memberDocumentsExtractionBulkFailed',
    defaultMessage:
      'Unable to start Zori analysis for the selected documents. Skipped {skipped, plural, one {# document} other {# documents}} that were already analyzed or in progress.',
  },
  memberDocumentsExtractionBulkNoSelection: {
    id: 'MemberDetail.memberDocumentsExtractionBulkNoSelection',
    defaultMessage: 'Select one or more documents to analyze with Zori AI.',
  },
  memberDocumentsExtractionBulkSelectionCount: {
    id: 'MemberDetail.memberDocumentsExtractionBulkSelectionCount',
    defaultMessage:
      '{count, plural, one {# document selected} other {# documents selected}}',
  },
  memberDocumentsExtractionTitle: {
    id: 'MemberDetail.memberDocumentsExtractionTitle',
    defaultMessage: 'Analyze document with Zori AI',
  },
  memberDocumentsExtractionClose: {
    id: 'MemberDetail.memberDocumentsExtractionClose',
    defaultMessage: 'Close',
  },
  memberDocumentsExtractionStart: {
    id: 'MemberDetail.memberDocumentsExtractionStart',
    defaultMessage: 'Analyze with Zori AI',
  },
  memberDocumentsExtractionRestart: {
    id: 'MemberDetail.memberDocumentsExtractionRestart',
    defaultMessage: 'Re-analyze with Zori AI',
  },
  memberDocumentsExtractionStarting: {
    id: 'MemberDetail.memberDocumentsExtractionStarting',
    defaultMessage: 'Starting analysis…',
  },
  memberDocumentsExtractionInProgressAction: {
    id: 'MemberDetail.memberDocumentsExtractionInProgressAction',
    defaultMessage: 'Analysis in progress…',
  },
  memberDocumentsExtractionUnknownDocument: {
    id: 'MemberDetail.memberDocumentsExtractionUnknownDocument',
    defaultMessage: 'Selected document',
  },
  memberDocumentsExtractionDescription: {
    id: 'MemberDetail.memberDocumentsExtractionDescription',
    defaultMessage:
      'Zori AI will analyze this document and extract relevant information for review.',
  },
  memberDocumentsExtractionTasks: {
    id: 'MemberDetail.memberDocumentsExtractionTasks',
    defaultMessage: 'Active and recent tasks for this member',
  },
  memberDocumentsExtractionNoTasks: {
    id: 'MemberDetail.memberDocumentsExtractionNoTasks',
    defaultMessage: 'No extraction tasks found for this member.',
  },
  memberDocumentsExtractionTask: {
    id: 'MemberDetail.memberDocumentsExtractionTask',
    defaultMessage: '{status} · {source}',
  },
  memberDocumentsExtractionThisDocument: {
    id: 'MemberDetail.memberDocumentsExtractionThisDocument',
    defaultMessage: 'this document',
  },
  memberDocumentsExtractionStatus: {
    id: 'MemberDetail.memberDocumentsExtractionStatus',
    defaultMessage: 'Selected task status',
  },
  memberDocumentsExtractionStatusColumn: {
    id: 'MemberDetail.memberDocumentsExtractionStatusColumn',
    defaultMessage: 'AI Extraction Status',
  },
  memberDocumentsExtractionStatusNone: {
    id: 'MemberDetail.memberDocumentsExtractionStatusNone',
    defaultMessage: 'not extracted',
  },
  memberDocumentsExtractionStatusPending: {
    id: 'MemberDetail.memberDocumentsExtractionStatusPending',
    defaultMessage: 'Pending',
  },
  memberDocumentsExtractionStatusProcessing: {
    id: 'MemberDetail.memberDocumentsExtractionStatusProcessing',
    defaultMessage: 'Processing',
  },
  memberDocumentsExtractionStatusFailed: {
    id: 'MemberDetail.memberDocumentsExtractionStatusFailed',
    defaultMessage: 'Failed',
  },
  memberDocumentsExtractionStatusDone: {
    id: 'MemberDetail.memberDocumentsExtractionStatusDone',
    defaultMessage: 'complete',
  },
  memberDocumentsExtractionStatusValue: {
    id: 'MemberDetail.memberDocumentsExtractionStatusValue',
    defaultMessage: 'Status: {status}',
  },
  memberDocumentsExtractionSummaryAvailable: {
    id: 'MemberDetail.memberDocumentsExtractionSummaryAvailable',
    defaultMessage: 'AI summary available: {value}',
  },
  memberDocumentsExtractionMetadata: {
    id: 'MemberDetail.memberDocumentsExtractionMetadata',
    defaultMessage:
      'Pages: {pages} · Candidate facts: {candidates} · Errors: {errors} · FHIR projections: {projections}',
  },
  memberDocumentsExtractionArtifactVersion: {
    id: 'MemberDetail.memberDocumentsExtractionArtifactVersion',
    defaultMessage: 'Artifact version: {version}',
  },
  memberDocumentsExtractionSelectTask: {
    id: 'MemberDetail.memberDocumentsExtractionSelectTask',
    defaultMessage: 'Select a task or start a new extraction.',
  },
  memberDocumentsExtractionModalStatusHint: {
    id: 'MemberDetail.memberDocumentsExtractionModalStatusHint',
    defaultMessage: 'Start Zori AI analysis to see progress.',
  },
  memberDocumentsExtractionInProgressHint: {
    id: 'MemberDetail.memberDocumentsExtractionInProgressHint',
    defaultMessage: 'Zori AI is analyzing and extracting this document.',
  },
  memberDocumentsExtractionSummary: {
    id: 'MemberDetail.memberDocumentsExtractionSummary',
    defaultMessage: 'Extracted summary',
  },
  memberDocumentsExtractionSummaryEmpty: {
    id: 'MemberDetail.memberDocumentsExtractionSummaryEmpty',
    defaultMessage:
      'No saved Zori AI summary is available for this document yet.',
  },
  memberDocumentsExtractionSummaryUnavailable: {
    id: 'MemberDetail.memberDocumentsExtractionSummaryUnavailable',
    defaultMessage:
      'A saved Zori AI summary was found, but it cannot be displayed right now.',
  },
  memberDocumentsExtractionResources: {
    id: 'MemberDetail.memberDocumentsExtractionResources',
    defaultMessage: 'Projection audit and persisted artifacts',
  },
  memberDocumentsExtractionObservations: {
    id: 'MemberDetail.memberDocumentsExtractionObservations',
    defaultMessage: 'Clinical resources for review',
  },
  memberDocumentsExtractionObservationResourceId: {
    id: 'MemberDetail.memberDocumentsExtractionObservationResourceId',
    defaultMessage: 'Resource ID: {id}',
  },
  memberDocumentsExtractionObservationsLoadError: {
    id: 'MemberDetail.memberDocumentsExtractionObservationsLoadError',
    defaultMessage:
      'Unable to load persisted clinical resources right now. Please try again later.',
  },
  memberDocumentsExtractionResourcesEmpty: {
    id: 'MemberDetail.memberDocumentsExtractionResourcesEmpty',
    defaultMessage:
      'No projection audit rows or persisted artifacts are available yet.',
  },
  memberDocumentsExtractionReviewSection: {
    id: 'MemberDetail.memberDocumentsExtractionReviewSection',
    defaultMessage: 'Extracted clinical resources',
  },
  memberDocumentsExtractionReviewSectionOther: {
    id: 'MemberDetail.memberDocumentsExtractionReviewSectionOther',
    defaultMessage: 'Other extracted clinical resources',
  },
  memberDocumentsExtractionReviewEmpty: {
    id: 'MemberDetail.memberDocumentsExtractionReviewEmpty',
    defaultMessage:
      'Zori AI did not extract any clinical resources to review from this note.',
  },
  // Documents surface Observations separately and only show this section once
  // something reviewable exists, so the copy has to stay true after the last
  // card is approved or rejected rather than claiming nothing was extracted.
  memberDocumentsExtractionReviewEmptyDocument: {
    id: 'MemberDetail.memberDocumentsExtractionReviewEmptyDocument',
    defaultMessage: 'No extracted clinical resources are waiting for review.',
  },
  memberDocumentsExtractionReviewUnpersisted: {
    id: 'MemberDetail.memberDocumentsExtractionReviewUnpersisted',
    defaultMessage:
      '{count, plural, one {# extracted clinical resource could not be saved} other {# extracted clinical resources could not be saved}} and {count, plural, one {is} other {are}} not available to review. See Technical details.',
  },
  memberDocumentsExtractionReviewUnpersistedDocument: {
    id: 'MemberDetail.memberDocumentsExtractionReviewUnpersistedDocument',
    defaultMessage:
      '{count, plural, one {# extracted clinical resource could not be saved} other {# extracted clinical resources could not be saved}} and {count, plural, one {is} other {are}} not available to review. See the projection audit below.',
  },
  memberDocumentsExtractionReviewLoading: {
    id: 'MemberDetail.memberDocumentsExtractionReviewLoading',
    defaultMessage: 'Loading extracted clinical resources…',
  },
  memberDocumentsExtractionReviewLoadError: {
    id: 'MemberDetail.memberDocumentsExtractionReviewLoadError',
    defaultMessage:
      'We could not load the extracted clinical resources for review. Please try again.',
  },
  memberDocumentsExtractionTechnicalDetails: {
    id: 'MemberDetail.memberDocumentsExtractionTechnicalDetails',
    defaultMessage: 'Technical details',
  },
  memberDocumentsExtractionSourceNote: {
    id: 'MemberDetail.memberDocumentsExtractionSourceNote',
    defaultMessage: 'Source note',
  },
  memberDocumentsExtractionSummaryLoadError: {
    id: 'MemberDetail.memberDocumentsExtractionSummaryLoadError',
    defaultMessage:
      'Unable to load the saved Zori AI summary right now. Please try again later.',
  },
  memberDocumentsExtractionModalNote: {
    id: 'MemberDetail.memberDocumentsExtractionModalNote',
    defaultMessage:
      "When Zori AI is finished, you will be able to view the extracted results from this member's Documents page.",
  },
  memberDocumentsExtractionSourceDocument: {
    id: 'MemberDetail.memberDocumentsExtractionSourceDocument',
    defaultMessage: 'Source document',
  },
  memberDocumentsExtractionSourceQuestionnaireResponse: {
    id: 'MemberDetail.memberDocumentsExtractionSourceQuestionnaireResponse',
    defaultMessage: 'Source survey response',
  },
  memberDocumentsExtractionHideSource: {
    id: 'MemberDetail.memberDocumentsExtractionHideSource',
    defaultMessage: 'Hide source document',
  },
  memberDocumentsExtractionShowSource: {
    id: 'MemberDetail.memberDocumentsExtractionShowSource',
    defaultMessage: 'Show source document',
  },
  memberDocumentsExtractionFindSource: {
    id: 'MemberDetail.memberDocumentsExtractionFindSource',
    defaultMessage: 'Find source for {label}',
  },
  memberDocumentsExtractionSourceSearchNoMatch: {
    id: 'MemberDetail.memberDocumentsExtractionSourceSearchNoMatch',
    defaultMessage: 'No matching source text was found in this document.',
  },
  memberDocumentsExtractionSourceLoadError: {
    id: 'MemberDetail.memberDocumentsExtractionSourceLoadError',
    defaultMessage:
      'Unable to load the source document right now. Please try again later.',
  },
  memberDocumentsExtractionNote: {
    id: 'MemberDetail.memberDocumentsExtractionNote',
    defaultMessage:
      'This validation view shows safe task metadata first. Full markdown summary display follows when durable FHIR artifacts are enabled.',
  },
  memberRuleActionAuditRuleActionsTab: {
    id: 'MemberDetail.memberRuleActionAudit.ruleActionsTab',
    defaultMessage: 'Rule Actions',
  },
  memberRuleActionAuditExtractionTasksTab: {
    id: 'MemberDetail.memberRuleActionAudit.extractionTasksTab',
    defaultMessage: 'Extraction Tasks',
  },
  memberRuleActionAuditPulseTasksTab: {
    id: 'MemberDetail.memberRuleActionAudit.pulseTasksTab',
    defaultMessage: 'Pulse Tasks',
  },
  memberRuleActionAuditNotificationsTab: {
    id: 'MemberDetail.memberRuleActionAudit.notificationsTab',
    defaultMessage: 'Member Notifications',
  },
  memberPulseScanTasksLoadError: {
    id: 'MemberDetail.memberPulseScanTasks.loadError',
    defaultMessage: 'Unable to load Zori Pulse scan tasks.',
  },
  memberPulseScanTasksEmpty: {
    id: 'MemberDetail.memberPulseScanTasks.empty',
    defaultMessage: 'No Zori Pulse scans found for this member',
  },
  memberPulseScanTasksSelect: {
    id: 'MemberDetail.memberPulseScanTasks.select',
    defaultMessage: 'Select a scan to view details',
  },
  memberPulseScanTasksSteps: {
    id: 'MemberDetail.memberPulseScanTasks.steps',
    defaultMessage: 'Scan steps',
  },
  memberPulseScanTasksNoSteps: {
    id: 'MemberDetail.memberPulseScanTasks.noSteps',
    defaultMessage: 'No scan steps recorded yet.',
  },
  memberPulseScanTasksChildNoResult: {
    id: 'MemberDetail.memberPulseScanTasks.childNoResult',
    defaultMessage: 'No result recorded for this step.',
  },
  memberDocumentsExtractionLoadError: {
    id: 'MemberDetail.memberDocumentsExtractionLoadError',
    defaultMessage: 'Unable to load extraction tasks.',
  },
  memberDocumentsExtractionInvokeError: {
    id: 'MemberDetail.memberDocumentsExtractionInvokeError',
    defaultMessage: 'Unable to start Zori AI analysis.',
  },
  memberDocumentsExtractionDuplicateTask: {
    id: 'MemberDetail.memberDocumentsExtractionDuplicateTask',
    defaultMessage:
      'Zori AI is already analyzing this document. Showing the current status.',
  },
  memberDocumentsExtractionCompleted: {
    id: 'MemberDetail.memberDocumentsExtractionCompleted',
    defaultMessage: 'Zori AI finished analyzing this document.',
  },
  memberDocumentsExtractionFailed: {
    id: 'MemberDetail.memberDocumentsExtractionFailed',
    defaultMessage: 'Zori AI was unable to analyze this document.',
  },
  memberDocumentsExtractionProvenanceTitle: {
    id: 'MemberDetail.memberDocumentsExtractionProvenanceTitle',
    defaultMessage: 'Document Extraction V2',
  },
  memberDocumentsExtractionProvenanceDescription: {
    id: 'MemberDetail.memberDocumentsExtractionProvenanceDescription',
    defaultMessage: 'AI-extracted resource pending clinical review.',
  },
  memberDocumentsExtractionProvenanceApproved: {
    id: 'MemberDetail.memberDocumentsExtractionProvenanceApproved',
    defaultMessage: 'Extraction approved by {user} at {time}.',
  },
  memberDocumentsExtractionProvenanceApprove: {
    id: 'MemberDetail.memberDocumentsExtractionProvenanceApprove',
    defaultMessage: 'Approve extraction',
  },
  memberDocumentsExtractionProvenanceApproving: {
    id: 'MemberDetail.memberDocumentsExtractionProvenanceApproving',
    defaultMessage: 'Approving...',
  },
  memberDocumentsExtractionProvenanceApproveSuccess: {
    id: 'MemberDetail.memberDocumentsExtractionProvenanceApproveSuccess',
    defaultMessage: 'Extraction approved.',
  },
  memberDocumentsExtractionProvenanceReject: {
    id: 'MemberDetail.memberDocumentsExtractionProvenanceReject',
    defaultMessage: 'Reject extraction',
  },
  memberDocumentsExtractionProvenanceRejecting: {
    id: 'MemberDetail.memberDocumentsExtractionProvenanceRejecting',
    defaultMessage: 'Rejecting...',
  },
  memberDocumentsExtractionProvenanceRejectTitle: {
    id: 'MemberDetail.memberDocumentsExtractionProvenanceRejectTitle',
    defaultMessage: 'Reject extracted resource?',
  },
  memberDocumentsExtractionProvenanceCancel: {
    id: 'MemberDetail.memberDocumentsExtractionProvenanceCancel',
    defaultMessage: 'Cancel',
  },
  memberDocumentsExtractionProvenanceRejectDescription: {
    id: 'MemberDetail.memberDocumentsExtractionProvenanceRejectDescription',
    defaultMessage:
      'Rejecting this extraction will remove the extracted resource and its extraction provenance.',
  },
  memberDocumentsExtractionProvenanceRejectReasonLabel: {
    id: 'MemberDetail.memberDocumentsExtractionProvenanceRejectReasonLabel',
    defaultMessage: 'Reason for rejecting (optional)',
  },
  memberDocumentsExtractionProvenanceRejectReasonPlaceholder: {
    id: 'MemberDetail.memberDocumentsExtractionProvenanceRejectReasonPlaceholder',
    defaultMessage:
      'e.g. Wrong code, incorrect date, or value belongs to a different resource',
  },
  memberDocumentsExtractionProvenanceRejectCorrectedValueLabel: {
    id: 'MemberDetail.memberDocumentsExtractionProvenanceRejectCorrectedValueLabel',
    defaultMessage: 'Correct value (optional)',
  },
  memberDocumentsExtractionProvenanceRejectCorrectedValuePlaceholder: {
    id: 'MemberDetail.memberDocumentsExtractionProvenanceRejectCorrectedValuePlaceholder',
    defaultMessage: 'e.g. Type 2 diabetes mellitus',
  },
  memberDocumentsExtractionProvenanceRejectFeedbackHelp: {
    id: 'MemberDetail.memberDocumentsExtractionProvenanceRejectFeedbackHelp',
    defaultMessage:
      'Your feedback is sent to Zori AI the next time this document is re-analyzed so it can correct the mistake.',
  },
  memberDocumentsExtractionProvenanceRejectSuccess: {
    id: 'MemberDetail.memberDocumentsExtractionProvenanceRejectSuccess',
    defaultMessage: 'Extraction rejected and removed.',
  },
  memberDocumentsExtractionProvenanceFeedbackError: {
    id: 'MemberDetail.memberDocumentsExtractionProvenanceFeedbackError',
    defaultMessage: 'Unable to save extraction feedback. Please try again.',
  },
  memberDocumentsExtractionProvenanceSourceDocument: {
    id: 'MemberDetail.memberDocumentsExtractionProvenanceSourceDocument',
    defaultMessage: 'Source: {source}',
  },
  memberDocumentsExtractionProvenanceUnknownSourceDocument: {
    id: 'MemberDetail.memberDocumentsExtractionProvenanceUnknownSourceDocument',
    defaultMessage: 'Unknown source',
  },
  memberPulseReviewSourceLoading: {
    id: 'MemberDetail.memberPulseReviewSourceLoading',
    defaultMessage: 'Loading source document…',
  },
  memberPulseReviewSourceNote: {
    id: 'MemberDetail.memberPulseReviewSourceNote',
    defaultMessage: 'Source note',
  },
  memberPulseReviewSourceNoteEmpty: {
    id: 'MemberDetail.memberPulseReviewSourceNoteEmpty',
    defaultMessage: 'This note has no content.',
  },
  memberPulseReviewQueueTitle: {
    id: 'MemberDetail.memberPulseReviewQueueTitle',
    defaultMessage: 'Review {count} extractions from this document',
  },
  memberPulseReviewQueueSubtitle: {
    id: 'MemberDetail.memberPulseReviewQueueSubtitle',
    defaultMessage:
      '{count, plural, one {# extraction} other {# extractions}} from this source document',
  },
  memberDocumentsExtractionProvenanceOpenSource: {
    id: 'MemberDetail.memberDocumentsExtractionProvenanceOpenSource',
    defaultMessage: 'Open source',
  },
  memberDocumentsExtractionProvenanceExtractedAt: {
    id: 'MemberDetail.memberDocumentsExtractionProvenanceExtractedAt',
    defaultMessage: 'Extracted at: {recorded}',
  },
  memberDocumentsExtractionProvenanceLoadError: {
    id: 'MemberDetail.memberDocumentsExtractionProvenanceLoadError',
    defaultMessage:
      'Unable to load Document Extraction V2 source details right now.',
  },
  memberDocumentsExtractionReviewStatus: {
    id: 'MemberDetail.memberDocumentsExtractionReviewStatus',
    defaultMessage: 'Extraction',
  },
  memberDocumentsProvenance: {
    id: 'MemberDetail.memberDocumentsProvenance',
    defaultMessage: 'Provenance',
  },
  memberDocumentsProvenanceZoriAi: {
    id: 'MemberDetail.memberDocumentsProvenanceZoriAi',
    defaultMessage: 'Zori AI',
  },
  memberDocumentsExtractionReviewStatusNeedsReview: {
    id: 'MemberDetail.memberDocumentsExtractionReviewStatusNeedsReview',
    defaultMessage: 'Needs review',
  },
  memberDocumentsExtractionReviewStatusApproved: {
    id: 'MemberDetail.memberDocumentsExtractionReviewStatusApproved',
    defaultMessage: 'Approved',
  },
  notesLabel: {
    id: 'MemberDetail.notesLabel',
    defaultMessage: 'Notes',
  },
  notes: {
    id: 'MemberDetail.notes',
    defaultMessage: 'Notes',
  },
  notesTitle: {
    id: 'MemberDetail.notesTitle',
    defaultMessage: 'Title',
  },
  notesDate: {
    id: 'MemberDetail.notesDate',
    defaultMessage: 'Created',
  },
  notesMemberVisible: {
    id: 'MemberDetail.notesMemberVisible',
    defaultMessage: 'Member visible',
  },
  notesType: {
    id: 'MemberDetail.notesType',
    defaultMessage: 'Type',
  },
  notesAuthor: {
    id: 'MemberDetail.notesAuthor',
    defaultMessage: 'Author',
  },
  notesEmpty: {
    id: 'MemberDetail.notesEmpty',
    defaultMessage: 'No notes found',
  },
  memberNotesExtractionButton: {
    id: 'MemberDetail.memberNotesExtractionButton',
    defaultMessage: 'Analyze with Zori AI',
  },
  memberNotesExtractionTitle: {
    id: 'MemberDetail.memberNotesExtractionTitle',
    defaultMessage: 'Analyze note with Zori AI',
  },
  memberNotesExtractionDescription: {
    id: 'MemberDetail.memberNotesExtractionDescription',
    defaultMessage:
      'Zori AI will analyze this note and extract relevant information for review.',
  },
  memberNotesExtractionUnknownNote: {
    id: 'MemberDetail.memberNotesExtractionUnknownNote',
    defaultMessage: 'Selected note',
  },
  memberNotesExtractionModalNote: {
    id: 'MemberDetail.memberNotesExtractionModalNote',
    defaultMessage:
      "When Zori AI is finished, you will be able to view the extracted results from this member's Notes page.",
  },
  memberSurveyExtractionButton: {
    id: 'MemberDetail.memberSurveyExtractionButton',
    defaultMessage: 'Analyze with Zori AI',
  },
  memberSurveyExtractionTitle: {
    id: 'MemberDetail.memberSurveyExtractionTitle',
    defaultMessage: 'Analyze survey response with Zori AI',
  },
  memberSurveyExtractionDescription: {
    id: 'MemberDetail.memberSurveyExtractionDescription',
    defaultMessage:
      'Zori AI will analyze this survey response and extract relevant information for review.',
  },
  memberSurveyExtractionUnknownResponse: {
    id: 'MemberDetail.memberSurveyExtractionUnknownResponse',
    defaultMessage: 'Selected survey response',
  },
  memberSurveyExtractionModalNote: {
    id: 'MemberDetail.memberSurveyExtractionModalNote',
    defaultMessage:
      "When Zori AI is finished, you will be able to view the extracted results from this member's Surveys page.",
  },
  surveysSurveyColumn: {
    id: 'MemberDetail.surveysSurveyColumn',
    defaultMessage: 'Survey',
  },
  surveysDateColumn: {
    id: 'MemberDetail.surveysDateColumn',
    defaultMessage: 'Date',
  },
  surveysResponsesEmpty: {
    id: 'MemberDetail.surveysResponsesEmpty',
    defaultMessage: 'No completed survey responses found.',
  },
  notesError: {
    id: 'MemberDetail.notesError',
    defaultMessage: 'Error loading notes',
  },
  contentAiTools: {
    id: 'MemberDetail.contentAiTools',
    defaultMessage: 'Zori reports content goes here.',
  },
  contentPlaceholder: {
    id: 'MemberDetail.contentPlaceholder',
    defaultMessage: 'Member content goes here.',
  },
  omicsExplorer: {
    id: 'MemberDetail.omicsExplorer',
    defaultMessage: 'Omics Explorer',
  },
  omicsExplorerLabel: {
    id: 'MemberDetail.omicsExplorerLabel',
    defaultMessage: 'Omics Explorer',
  },
  elationLink: {
    id: 'MemberDetail.elationLink',
    defaultMessage: 'Elation',
  },
  chatClinicianLabel: {
    id: 'MemberDetail.chatClinicianLabel',
    defaultMessage: 'Clinician',
  },
  chatMemberHistoryLabel: {
    id: 'MemberDetail.chatMemberHistoryLabel',
    defaultMessage: 'Member History',
  },
  medications: {
    id: 'MemberDetail.medications',
    defaultMessage: 'Medications',
  },
  medicationsMedication: {
    id: 'MemberDetail.medicationsMedication',
    defaultMessage: 'Medication',
  },
  medicationsStatus: {
    id: 'MemberDetail.medicationsStatus',
    defaultMessage: 'Status',
  },
  medicationsIntent: {
    id: 'MemberDetail.medicationsIntent',
    defaultMessage: 'Intent',
  },
  medicationsDosage: {
    id: 'MemberDetail.medicationsDosage',
    defaultMessage: 'Dosage',
  },
  medicationsAuthoredOn: {
    id: 'MemberDetail.medicationsAuthoredOn',
    defaultMessage: 'Authored On',
  },
  medicationsPrescriber: {
    id: 'MemberDetail.medicationsPrescriber',
    defaultMessage: 'Prescriber',
  },
  medicationsEmpty: {
    id: 'MemberDetail.medicationsEmpty',
    defaultMessage: 'No medications found',
  },
  procedures: {
    id: 'MemberDetail.procedures',
    defaultMessage: 'Procedures',
  },
  proceduresCode: {
    id: 'MemberDetail.proceduresCode',
    defaultMessage: 'Code',
  },
  proceduresStatus: {
    id: 'MemberDetail.proceduresStatus',
    defaultMessage: 'Status',
  },
  proceduresPerformed: {
    id: 'MemberDetail.proceduresPerformed',
    defaultMessage: 'Performed',
  },
  proceduresPerformer: {
    id: 'MemberDetail.proceduresPerformer',
    defaultMessage: 'Performer',
  },
  proceduresCategory: {
    id: 'MemberDetail.proceduresCategory',
    defaultMessage: 'Category',
  },
  proceduresReason: {
    id: 'MemberDetail.proceduresReason',
    defaultMessage: 'Reason',
  },
  proceduresEmpty: {
    id: 'MemberDetail.proceduresEmpty',
    defaultMessage: 'No procedures found',
  },
  conditions: {
    id: 'MemberDetail.conditions',
    defaultMessage: 'Conditions',
  },
  conditionsCode: {
    id: 'MemberDetail.conditionsCode',
    defaultMessage: 'Code',
  },
  conditionsClinicalStatus: {
    id: 'MemberDetail.conditionsClinicalStatus',
    defaultMessage: 'Clinical Status',
  },
  conditionsVerificationStatus: {
    id: 'MemberDetail.conditionsVerificationStatus',
    defaultMessage: 'Verification Status',
  },
  conditionsOnset: {
    id: 'MemberDetail.conditionsOnset',
    defaultMessage: 'Onset',
  },
  conditionsCategory: {
    id: 'MemberDetail.conditionsCategory',
    defaultMessage: 'Category',
  },
  conditionsEmpty: {
    id: 'MemberDetail.conditionsEmpty',
    defaultMessage: 'No conditions found',
  },
  allergies: {
    id: 'MemberDetail.allergies',
    defaultMessage: 'Allergies',
  },
  allergiesAllergy: {
    id: 'MemberDetail.allergiesAllergy',
    defaultMessage: 'Allergy',
  },
  allergiesClinicalStatus: {
    id: 'MemberDetail.allergiesClinicalStatus',
    defaultMessage: 'Clinical Status',
  },
  allergiesVerificationStatus: {
    id: 'MemberDetail.allergiesVerificationStatus',
    defaultMessage: 'Verification Status',
  },
  allergiesCriticality: {
    id: 'MemberDetail.allergiesCriticality',
    defaultMessage: 'Criticality',
  },
  allergiesRecordedDate: {
    id: 'MemberDetail.allergiesRecordedDate',
    defaultMessage: 'Recorded Date',
  },
  allergiesEmpty: {
    id: 'MemberDetail.allergiesEmpty',
    defaultMessage: 'No allergies found',
  },
  detectedIssues: {
    id: 'MemberDetail.detectedIssues',
    defaultMessage: 'Detected issues',
  },
  detectedIssuesActiveTitle: {
    id: 'MemberDetail.detectedIssuesActiveTitle',
    defaultMessage: 'Active detected issues',
  },
  detectedIssuesReviewQueueTitle: {
    id: 'MemberDetail.detectedIssuesReviewQueueTitle',
    defaultMessage: 'Proposals needing review',
  },
  detectedIssuesCategory: {
    id: 'MemberDetail.detectedIssuesCategory',
    defaultMessage: 'Category',
  },
  detectedIssuesSeverity: {
    id: 'MemberDetail.detectedIssuesSeverity',
    defaultMessage: 'Severity',
  },
  detectedIssuesReviewStatus: {
    id: 'MemberDetail.detectedIssuesReviewStatus',
    defaultMessage: 'Review status',
  },
  detectedIssuesDetail: {
    id: 'MemberDetail.detectedIssuesDetail',
    defaultMessage: 'Summary',
  },
  detectedIssuesDate: {
    id: 'MemberDetail.detectedIssuesDate',
    defaultMessage: 'Date',
  },
  detectedIssuesEmpty: {
    id: 'MemberDetail.detectedIssuesEmpty',
    defaultMessage: 'No active detected issues found',
  },
  detectedIssuesReviewQueueEmpty: {
    id: 'MemberDetail.detectedIssuesReviewQueueEmpty',
    defaultMessage: 'No proposals need review',
  },
  detectedIssuesDetailTitle: {
    id: 'MemberDetail.detectedIssuesDetailTitle',
    defaultMessage: 'Detected issue',
  },
  detectedIssuesCitations: {
    id: 'MemberDetail.detectedIssuesCitations',
    defaultMessage: 'Citations',
  },
  documentExtractionDetectedIssuesTitle: {
    id: 'MemberDetail.documentExtractionDetectedIssuesTitle',
    defaultMessage: 'Proposed detected issues',
  },
  immunizations: {
    id: 'MemberDetail.immunizations',
    defaultMessage: 'Immunizations',
  },
  immunizationsVaccine: {
    id: 'MemberDetail.immunizationsVaccine',
    defaultMessage: 'Vaccine',
  },
  immunizationsStatus: {
    id: 'MemberDetail.immunizationsStatus',
    defaultMessage: 'Status',
  },
  immunizationsOccurrence: {
    id: 'MemberDetail.immunizationsOccurrence',
    defaultMessage: 'Occurrence',
  },
  immunizationsPerformer: {
    id: 'MemberDetail.immunizationsPerformer',
    defaultMessage: 'Performer',
  },
  immunizationsLotNumber: {
    id: 'MemberDetail.immunizationsLotNumber',
    defaultMessage: 'Lot Number',
  },
  immunizationsExpirationDate: {
    id: 'MemberDetail.immunizationsExpirationDate',
    defaultMessage: 'Expiration Date',
  },
  immunizationsPrimarySource: {
    id: 'MemberDetail.immunizationsPrimarySource',
    defaultMessage: 'Primary Source',
  },
  immunizationsSite: {
    id: 'MemberDetail.immunizationsSite',
    defaultMessage: 'Site',
  },
  immunizationsRoute: {
    id: 'MemberDetail.immunizationsRoute',
    defaultMessage: 'Route',
  },
  immunizationsDose: {
    id: 'MemberDetail.immunizationsDose',
    defaultMessage: 'Dose',
  },
  immunizationsNote: {
    id: 'MemberDetail.immunizationsNote',
    defaultMessage: 'Note',
  },
  immunizationsEmpty: {
    id: 'MemberDetail.immunizationsEmpty',
    defaultMessage: 'No immunizations found',
  },
  cohortMismatchIntro: {
    id: 'MemberDetail.cohortMismatchIntro',
    defaultMessage: 'This member is in a different cohort.',
  },
  cohortMismatchSwitchCohort: {
    id: 'MemberDetail.cohortMismatchSwitchCohort',
    defaultMessage: 'Switch to {cohortName}',
  },
  cohortMismatchOr: {
    id: 'MemberDetail.cohortMismatchOr',
    defaultMessage: 'or',
  },
  cohortMismatchAllCohorts: {
    id: 'MemberDetail.cohortMismatchAllCohorts',
    defaultMessage: 'Switch to all cohorts',
  },
  extractionsLabel: {
    id: 'MemberDetail.extractionsLabel',
    defaultMessage: 'Extractions',
  },
  extractions: {
    id: 'MemberDetail.extractions',
    defaultMessage: 'Extractions',
  },
  extractionsToApprove: {
    id: 'MemberDetail.extractionsToApprove',
    defaultMessage:
      '{count, plural, one {# extraction to approve} other {# extractions to approve}}',
  },
  pulseLabel: {
    id: 'MemberDetail.pulseLabel',
    defaultMessage: 'Zori Pulse',
  },
  pulseMenu: {
    id: 'MemberDetail.pulseMenu',
    defaultMessage: 'Zori Pulse',
  },
  landingPulseDescription: {
    id: 'MemberDetail.landingPulseDescription',
    defaultMessage:
      'AI-generated priority view with appointments, issues, and suggested actions',
  },
});
